export default {
    scalingFactor: 75,
    spriteOverlay: 20, // element must be bigger than grid box
};
